import { useMutation, useQueryClient } from "react-query";

import useUser from "./useUser";
import useSnackbar from "../components/snackbar/hooks/useSnackbar";
import { getErrorMessage } from "../utils/errors";
import { deleteCartItem } from "../apis/cartApi";
import { CART_ITEMS_QUERY_KEY } from "../queries-keys/cartItems";

const useDeleteCartItem = () => {
  const queryClient = useQueryClient();
  const { handleOpenSnackbar } = useSnackbar();
  const { user } = useUser();

  const {
    mutate: deleteCartItemMutation,
    isLoading: isDeleteingCartItemLoading,
  } = useMutation({
    mutationFn: deleteCartItem,
    onSuccess: () => {
      queryClient.invalidateQueries(CART_ITEMS_QUERY_KEY(user?.id));
    },
    onError: (error) => {
      handleOpenSnackbar(getErrorMessage(error), "error");
    },
  });

  return {
    deleteCartItemMutation,
    isDeleteingCartItemLoading,
  };
};

export default useDeleteCartItem;
